/**
 * Sticky-note palettes for /quotes and Finder Cover Flow thumbs.
 * Color assignment is deterministic from quote text + index so both surfaces match.
 */

export interface QuoteStickyPalette {
  backgroundColor: string;
  color: string;
}

export interface QuoteStickyStyle extends QuoteStickyPalette {
  rotate: string;
  width: number;
}

export const QUOTE_STICKY_PALETTES: readonly QuoteStickyPalette[] = [
  { backgroundColor: '#093145', color: '#ffffff' },
  { backgroundColor: '#0C374D', color: '#ffffff' },
  { backgroundColor: '#0D3D56', color: '#ffffff' },
  { backgroundColor: '#ffffff', color: '#093145' },
  { backgroundColor: '#FFF7AE', color: '#333333' },
  { backgroundColor: '#FFD6E8', color: '#333333' },
  { backgroundColor: '#D4F4DD', color: '#333333' },
];

export function quoteStickyHash(seed: string): number {
  let hash = 0;
  for (let i = 0; i < seed.length; i++) {
    hash = ((hash << 5) - hash) + seed.charCodeAt(i);
    hash = hash & hash;
  }
  return Math.abs(hash);
}

export function quoteStickyStyle(text: string, index: number): QuoteStickyStyle {
  const seed = quoteStickyHash(text + index);
  const palette = QUOTE_STICKY_PALETTES[seed % QUOTE_STICKY_PALETTES.length]!;
  return {
    backgroundColor: palette.backgroundColor,
    color: palette.color,
    rotate: `${(seed % 10000) / 1000 - 5}deg`,
    width: (seed % 300) + 300,
  };
}
